export default __webpack_public_path__ + "static/media/Ballroll_00132.9d0d821a.png";